import { render } from "./index.vue?vue&type=template&id=3db8717c"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=3db8717c&lang=less"
script.render = render

export default script